import { OBJECT_CARD_SETTINGS_FIELD, ObjectCardKind } from '@common/components/object-card';

export const selectCurrentUser = (state: any) => state.currentUser.currentUser;
export const selectCurrenUserVisibleObjectsCount = (state: any) =>
  state.currentUser.currentUser.visibleObjectsCount;
export const selectCurrentUserVisibleGeozoneIds = (state: any) =>
  state.currentUser.currentUser.visibleGeozoneIds;
/** Настройки всплывающей карточки объекта */
export const selectCurrentUserObjectCardSettings = (state: any) =>
  state.currentUser.currentUser.objectCardSettings;
/** Настройки фиксированной карточки объекта */
export const selectCurrentUserObjectCardFixed = (state: any) =>
  state.currentUser.currentUser?.objectCardFixed;
/** Настройки карточки объекта по её типу */
export const selectCurrentUserObjectCardSettingsByKind = (kind: ObjectCardKind) => (state: any) =>
  state.currentUser.currentUser?.[OBJECT_CARD_SETTINGS_FIELD[kind]];
export const selectCurrentUserAccountId = (state: any) => state.currentUser.currentUser.accountId;
export const selectCurrentUserMapObjectSettings = (state: any) =>
  state.currentUser.currentUser?.mapObjectSettings;
